module.exports = __webpack_public_path__ + "static/media/treasurer.a8801877.png";